import CarPageBasicComponent from './car-page-basic-component';

/**
 * CarPageAddCartModal controls the modal box that opens when user adds item to the shopping cart.
 */
class CarPageAddCartModal extends CarPageBasicComponent {
  state = { addCartDialog: false };

  /**
   * Initializes the component: renders, binds, starts observers etc...
   * @param {[CarPageApp]} carPageApp optional, if doesn't exist, it's created. (The CarPageApp component is a singleton)
   */
  constructor(carPageApp) {
    super(carPageApp);
    this.element = document.querySelector('#carcard-addcart-modal');

    if (this.element) {
      this.initState();
      this.render();
      this.bind(['observeIndependentChange']);
      this.initControls();
    }
  }

  /**
   * initializes the component's control elements. Both close button and "Jatka ostoksia" -button closes the dialog.
   * Also starts an observer that detects if the dialog closes independently, and passes the info down.
   */
  initControls() {
    this.closeButton = this.element.querySelector('nav.contentcard-titlecontrol');
    this.continueShoppingButton = this.element.querySelector('button.continue-shopping-button');
    this.closeButton.addEventListener('click', this.toggleDialogState.bind(this));
    this.continueShoppingButton.addEventListener('click', this.toggleDialogState.bind(this));
    this.initIndependetChangesObserver();
  }

  /**
   * The elevated container has a clickable overlay that can close the dialog.
   * This starts an observer to watch the modal for changes, in case it closes independently.
   */
  initIndependetChangesObserver() {
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(this.observeIndependentChange);

    // Start observing the target node for configured mutations
    observer.observe(this.element, { attributes: true, childList: false, subtree: false });
  }

  /**
   * MutationObserver callback https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
   * @param  {MutationRecord[]} mutations https://developer.mozilla.org/en-US/docs/Web/API/MutationRecord
   */
  observeIndependentChange(mutations) {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (this.elementVisibility !== this.state.addCartDialog) {
          this.app.updateState('dialogs.addCartDialog', this.elementVisibility);
        }
      }
    });
  }

  /**
   * Toggles the state dialogState and passes it to controller.
   */
  toggleDialogState() {
    this.app.updateState('dialogs.addCartDialog', !this.state.addCartDialog);
  }

  /**
   * Isolate from the entire app state only the part that concerns the component,
   * and only observe changes in that sub state.
   * @param  {object} state receives the app state from controller app
   * @return {object} the isolated sub state, for example state.calculator.calculatorType
   */
  filterState(state) {
    // eslint-disable-next-line no-prototype-builtins
    if (typeof state === 'object' && state.hasOwnProperty('dialogs')) {
      return { ...state.dialogs };
    }
    return {};
  }

  /**
   * getter, reads the visibility value of the actual element. (This is a bad practise generally,
   * but needed to bridge the non-compatible element with the new state logic)
   * @return {boolean} true = visible, false = not visible
   */
  get elementVisibility() {
    if (!this.element) return false;
    return this.element.classList.contains('visible');
  }

  /**
   * Updates the visible component when asked. In this case calls the visibility
   * toggle of the external component.
   */
  render() {
    if (this.element && this.state.addCartDialog !== this.elementVisibility) {
      this.element.toggleVisibility(this.state.addCartDialog);
    }
  }
}

export default CarPageAddCartModal;
